import { AdminScaleChildResponse, AdminScaleId, AdminScaleChildId, AdminScaleResponse, TreeNode } from '@business/entities/adminscale';
import { CommonService } from '@business/services';
import { Endpoint } from '../endpoint';
import { CompanyId } from '@business/entities/companies';

export function fetchAdminScales(adminScaleId: AdminScaleId, isCompact?: boolean) {
  return Endpoint.get<AdminScaleResponse[]>(`@makh/adminscales`, { params: { adminScaleId, isCompact } });
}

export function fetchAdminScale(id: AdminScaleId) {
  return Endpoint.get<AdminScaleResponse>(`@makh/adminscales/adminscale/${id}`);
}

export function createAdminScale(data: Partial<AdminScaleResponse>) {
  return Endpoint.post<AdminScaleResponse>(`@makh/adminscales`, { data });
}

export function updateAdminScale(adminScaleId: AdminScaleId, data: Partial<AdminScaleResponse>) {
  return Endpoint.patch<AdminScaleResponse>(`@makh/adminscales/${adminScaleId}`, { data });
}

export function deleteAdminScale(adminScaleId: AdminScaleId) {
  return Endpoint.delete<void>(`@makh/adminscales/${adminScaleId}`);
}
